import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppRootState} from '../../appStore';
import {DrawerTypeValue} from 'types';

export interface appDrawerState {
    isLeftDrawerOpened: boolean;
    isRightDrawerOpened: DrawerTypeValue | null;
    isLoading: boolean;
    isRightDrawerPinned: boolean;
}

let initialState: appDrawerState = {
    isLeftDrawerOpened: false,
    isRightDrawerOpened: null,
    isLoading: false,
    isRightDrawerPinned: false,
};

export const appDrawerSlice = createSlice({
    name: 'drawer',
    initialState,
    reducers: {
        handleLeftAppDrawerState: state => {
            state.isLeftDrawerOpened = !state.isLeftDrawerOpened;
        },
        setRightDrawerState: (state, action: PayloadAction<DrawerTypeValue | null>) => {
            state.isRightDrawerOpened = action.payload;
        },
        setIsRightDrawerPinned: (state, action: PayloadAction<boolean>) => {
            state.isRightDrawerPinned = action.payload;
        },

        setAppDrawerState: (state, action: PayloadAction<boolean>) => {
            state.isLeftDrawerOpened = action.payload;
        },

        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
});

export const {handleLeftAppDrawerState, setIsRightDrawerPinned, setAppDrawerState, setIsLoading, setRightDrawerState} =
    appDrawerSlice.actions;

export const appDrawerSliceReducer = appDrawerSlice.reducer;
export const appDrawerSelector = (rootState: AppRootState): appDrawerState => rootState.drawer;
